
export { CollectionName } from "/codebuild/output/src4106288217/src/packages/search-document-builders/src/registry/collection-registry.ts"
export { collectionAlias } from "./registry/schema-registry"